
<div class="dx-field">
  <h5>{{username}}</h5>
</div>
<div class="dx-field">
  <dx-text-box mode="password" [(value)]="password" placeholder="Password" width="100%">
    <dx-validator>
      <dxi-validation-rule type="required" message="Password is required"></dxi-validation-rule>
    </dx-validator>
  </dx-text-box>
</div>
<div style="margin-top: 20px;">
  Requisiti nuova password:
  <ul>
    <li>Lunghezza minima: {{parametriPasswords.lunghezzaMinimaPassword}}</li>
    @if (parametriPasswords.minimoMaiuscolePassword > 0) {
      <li>Numero minimo di lettere maiuscole: {{parametriPasswords.minimoMaiuscolePassword}}</li>
    }
    @if (parametriPasswords.minimoMinuscolePassword > 0) {
      <li>Numero minimo di lettere minuscole: {{parametriPasswords.minimoMinuscolePassword}}</li>
    }
    @if (parametriPasswords.minimoNumeriPassword > 0) {
      <li>Numero minimo di cifre: {{parametriPasswords.minimoNumeriPassword}}</li>
    }
    @if (parametriPasswords.minimoCaratteriSpecialiPassword > 0) {
      <li>Numero minimo di caratteri speciali: {{parametriPasswords.minimoCaratteriSpecialiPassword}}</li>
    }
    <li>La password non può coincidere con un'altra usata negli ultimi 12 mesi</li>
  </ul>
  <i>Ricordiamo che la password ha validità di {{parametriPasswords.mesiScadenzaPassword}} mesi</i>
</div>
<div class="dx-field">
  <dx-text-box mode="password" [(value)]="newPassword" placeholder="Nuova Password" width="100%">
    <dx-validator>
      <dxi-validation-rule type="required" message="Inserire nuova password"></dxi-validation-rule>
    </dx-validator>
  </dx-text-box>
</div>
<div class="dx-field">
  <dx-text-box mode="password" [(value)]="newPassword2" placeholder="Conferma nuova Password" width="100%">
    <dx-validator>
      <dxi-validation-rule type="required" message="Confermare nuova password"></dxi-validation-rule>
    </dx-validator>
  </dx-text-box>
</div>
@if (errMsg) {
  <div class="dx-field">
    <span style="color:darkred;">{{errMsg}}</span>
  </div>
}
<div class="dx-field">
  <dx-button type="default" id="button" (click)="onBtnConfermaClick()" [height]="40" width="-webkit-fill-available">
    <span class="dx-button-text">Conferma</span>
  </dx-button>
</div>
